import styled from 'styled-components/macro'

import { theme, fluidSystem, mediaM, mediaShort } from 'styled'

export const Root = styled.div``

export const ContentWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  margin: auto;

  > .Inner {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  ${mediaM`
    max-width: 632px;
  `};
`

export const TransitionWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`
export const Header = styled.div`
  flex: 0 0 auto;
  width: 100%;
  opacity: ${({ leaving, entering }) => (leaving || entering ? 0 : 1)};
  transform: translate(0, ${({ entering, leaving }) => (leaving ? -100 : entering ? 100 : 0)}%);
  transition: all 0.3s ${({ leaving }) => (leaving ? 0 : 0.2)}s;

  .QuestionText {
    ${mediaShort`
      line-height: 1.15;
      font-size: 18px;
    `};
  }
`

export const Lead = styled.div`
  ${fluidSystem};
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-transform: uppercase;
  border-bottom: 1px solid rgba(221, 221, 221, 0.5);
`

export const Icon = styled.div`
  width: ${({ entering }) => (entering ? 0 : 72)}px;
  height: 48px;
  overflow: hidden;
  transition: all 0.3s 0.9s;

  > svg {
    width: auto;
    height: 100%;
  }
`
export const HeaderQuestion = styled.div`
  width: 100%;
  max-width: 300px;
`
export const HeaderIcon = styled.div`
  ${fluidSystem};
  flex: 0 0 auto;

  svg {
    width: 100%;
    height: auto;
  }
`
export const BurgerButton = styled.div`
  position: relative;
  flex: 0 0 auto;
  width: 16px;
  height: 11px;
  /* border-top: 1px solid ${theme.presets.colors.primary};
  border-bottom: 1px solid ${theme.presets.colors.primary}; */
  margin-right: 24px;

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    /* background-color: ${theme.presets.colors.primary}; */
    left: 0;
    top: 4px;
  }

  ${mediaM`
    display: none;
    `};
`

export const Body = styled.div`
  position: relative;
  flex: 0 999 100%;
  width: 100%;
  margin: auto;

  > .Inner {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  ${mediaM`
    max-width: 632px;
  `};
`

export const QuestionText = styled.div`
  ${fluidSystem};

  ${mediaM`
    max-width: 50%;
  `};
`

export const OptionsRoot = styled.div``

export const OptionBox = styled.div`
  ${fluidSystem};
  position: relative;
  height: 54px;
  border-radius: 27px;
  /* background-color: ${({ selected }) => theme.presets.colors[selected ? 'primary' : 'white']};
  color: ${({ selected }) => theme.presets.colors[selected ? 'white' : 'body']}; */
  transform: rotate(${({ dragging }) => (dragging ? 4 : 0)}deg);
  display: flex;
  align-items: center;
  padding: 0 24px;
  margin-bottom: 8px;
  transition: all 0.2s;

  &:hover {
    cursor: pointer;
  }

  &:after {
    content: '';
    position: absolute;
    left: 2px;
    top: 2px;
    right: 2px;
    bottom: 2px;
    border-radius: 33px;
    border: 2px solid rgba(255, 255, 255, 0.5);
  }

  ${mediaM`
    height: 70px;
    border-radius: 35px;
    `};
`

export const Footer = styled.div`
  width: 100%;
`

export const FooterRow = styled.div`
  ${fluidSystem};
  display: flex;
  justify-content: flex-end;
  align-items: center;

  &:not(:last-child) {
    /* border-bottom: 1px solid ${theme.presets.colors.faintGrey}; */
  }
`

export const HintBox = styled.div`
  position: relative;
  flex: 0 999 100%;

  > * {
    width: 100%;
  }
`

export const Hint = styled.div`
  display: flex;
  align-items: center;

  .Icon:not(:empty) {
    margin-right: 16px;
  }
`
